var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"absolute",staticStyle:{"bottom":"50px","right":"30px","z-index":"9"},attrs:{"round":"","color":"primary","icon":"mdi-chevron-down"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('q-tooltip',[_vm._v("Ir para o final")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }